import SubscriptionPlan from "../types/enums/SubscriptionPlan"
import SubscriptionPlanTitles, { OldSubscriptionPlanTitles } from "./SubscriptionPlanTitles"

const getTitles = (titles: Record<SubscriptionPlan, string>) => {
  return Object.entries(titles).reduce(
    (acc, [key, value]) => {
      // @ts-expect-error: The code below works fine, but TypeScript throws an error
      acc[key] = `Nuve ${value}`
      return acc
    },
    {} as Record<SubscriptionPlan, string>,
  )
}

const SubscriptionPlanTitlesWithPrefix = getTitles(SubscriptionPlanTitles)

export const OldSubscriptionPlanTitlesWithPrefix = getTitles(OldSubscriptionPlanTitles)

export default SubscriptionPlanTitlesWithPrefix
